export const isTouchDevice = () => {
    try {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0
    } catch {
        throw new Error('Not allowed on the server!')
    }
}
